import request from "@/utils/request";
// 基地登录
export function loginApi(data) {
  return request({
    url: "/api/user/login",
    method: "post",
    data
  });
}
// 用户登录
export function userloginApi(data) {
  return request({
    url: "/api/member/passwordLogin",
    method: "post",
    data
  });
}

// jsapi创建订单接口(会员)
export function getPayMsg(data) {
  return request({
    url: "/api/wx/jsPay/jsPayRegister",
    method: "post",
    data
  });
}
// jsapi创建订单接口(会员单位)
export function getPayMsgUnit(data) {
  return request({
    url: "/api/wx/jsPay/jsPayRegisterUnits",
    method: "post",
    data
  });
}
// jsapi使用订单号获取支付信息接口
export function jsPay(params) {
  return request({
    url: "/api/wx/jsPay/pay",
    method: "get",
    params
  });
}

// 获取会费
export function commodity(params) {
  return request({
    url: "/api/commodity/get",
    method: "get",
    params
  });
}
// 创建注册订单
export function createOrder(data) {
  return request({
    url: "/api/wx/pay",
    method: "post",
    data
  });
}
export function createOrderUnit(data) {
  return request({
    url: "/api/wx/memberUnitsPay",
    method: "post",
    data
  });
}
// 查询注册订单
export function queryOrder(params) {
  return request({
    url: "/api/wx/query",
    method: "get",
    params
  });
}

// 用户注册
export function userRegister(data) {
  return request({
    url: "/api/member/register",
    method: "post",
    data
  });
}
// 会员单位注册
export function memberUnitRegister(data) {
  return request({
    url: "/api/memberUnits/register",
    method: "post",
    data
  });
}
// 退出登录
export function outloginApi() {
    return request({
      url: "/api/user/loginOut",
    });
}
// 获取验证码
export function getCode(params) {
  return request({
    url: "/api/phone/get",
    method: "get",
    params
  });
}
// 用户手机验证码登录
export function phoneLogin(params) {
  return request({
    url: "/api/member/phoneLogin",
    method: "get",
    params
  });
}
// 续费
export function renew(params) {
  return request({
    url: "api/member/renew",
    method: "get",
    params
  });
}
// 续费移动端
export function createRenewOrder(params) {
  return request({
    url: "api/wx/createRenewOrder",
    method: "get",
    params
  });
}
// 跳转中间页
export function jsPays(params) {
  return request({
    url: "api/wx/reNweJsPay",
    method: "get",
    params
  });
}